import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  generateOtp,
  generateMobOtp,
  verifyOtp,
  verifymobOtp,
} from "../configs/WebService";
import userStore from "../zustand/userStore";
import { useDispatch } from "react-redux";
import { apiKeyHeader } from "../configs/ApiKeys";
import { loginUser } from "../components/features/user/redux/signupThunk";
import { toast } from "react-toastify";
import { motion, AnimatePresence } from "framer-motion";
import { Toaster } from "react-hot-toast";

const OtpVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasInitialized = useRef(false);

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [step, setStep] = useState("email"); // "email" or "mobile"
  const [userPayload, setUserPayload] = useState(null); // Full payload from signup
  const payload = location.state?.formData || {};

  const parsedPayload =
    typeof payload === "string" ? JSON.parse(payload) : payload || {};

  //   const parsedPayload = payload ? JSON.parse(payload) : {};
  const source = location.state?.source;
  const phone = payload?.contactNumber || payload?.contact_number;
  const setUser = userStore.getState().setUser;

  //   useEffect(() => {
  //     setAppdAiGuest("registration");
  //   }, []);

  useEffect(() => {
    // 2. Only run the logic if it hasn't run before and state exists
    if (hasInitialized.current || !location.state) return;
    if (source === "login") {
      if (payload?.email && !phone) {
        setEmail(payload.email);
        setMobile("");
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      } else if (phone && !payload?.email) {
        setStep("mobile");
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToMobile(phone);
        hasInitialized.current = true; // Mark as done
      } else if (payload?.email && phone) {
        setEmail(payload.email);
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      }
    } else {
      // Signup Logic
      if (payload?.email && phone) {
        setEmail(payload.email);
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      } else {
        alert("No user data found. Redirecting...");
        navigate("/signup");
      }
    }
  }, [location, navigate]);

  const sendOtpToMobile = async (mobileNumber) => {
    try {
      const response = await fetch(generateMobOtp, {
        // Using your mobile config
        method: "POST",
        headers: apiKeyHeader(),
        // headers: { "Content-Type": "application/json" },
        // body: JSON.stringify({ otpType: "mobile", otpSentTo: mobileNumber }), // Ensure your backend expects 'to'
        body: JSON.stringify({ otpType: "mobile", to: mobileNumber }), // Ensure your backend expects 'to'
      });

      if (response.ok) {
        console.log("OTP sent successfully to mobile:", mobileNumber);
        document.dispatchEvent(
          new CustomEvent("mdm:otp", { detail: { status: "sent" } }),
        );
        alert("Now, an OTP has been sent to your mobile.");
      } else {
        alert(
          "Email verified, but failed to send Mobile OTP. Please use Resend.",
        );
      }
    } catch (error) {
      console.error("Mobile OTP error:", error);
    }
  };

  const sendOtpToEmail = async (email) => {
    try {
      const response = await fetch(generateOtp, {
        method: "POST",
        headers: apiKeyHeader(),
        // {
        //   "Content-Type": "application/json",
        // },
        body: JSON.stringify({ to: email, otpType: "email" }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("OTP sent successfully to:", email);
        document.dispatchEvent(
          new CustomEvent("mdm:otp", { detail: { status: "sent" } }),
        );
      } else {
        console.error("OTP send error:", data?.error || "Unknown error");
        alert("Failed to send OTP: " + (data?.error || "Please try again."));
      }
    } catch (error) {
      console.error("Network error while sending OTP:", error);
      alert("Network error. Please try again later.");
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otp) {
      alert("Please enter the OTP.");
      return;
    }

    setLoading(true);

    // 1. Determine which API and Payload to use based on the current step
    const apiUrl = step === "email" ? verifyOtp : verifymobOtp; // Update with your actual full mobile verify URL

    const payload =
      step === "email"
        ? { to: email, otp: otp, otpType: "email" }
        : {
            // otpSentTo: mobile,
            to: mobile,
            otp: otp,
            otpType: "mobile",
          };
    // : { to: mobile, otp: otp }; // Mobile usually expects 'otpSentTo' based on your previous thunk

    console.log("url", apiUrl);
    console.log("url-payload", JSON.stringify(payload));
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        // headers: { "Content-Type": "application/json" },
        headers: apiKeyHeader(),
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("data_182", data);

      if (response.ok) {
        if (step === "email") {
          // --- EMAIL SUCCESS ---
          document.dispatchEvent(
            new CustomEvent("mdm:otp", { detail: { status: "verified" } }),
          );
          alert("✅ Email Verified!");
          setOtp("");
          if (phone) {
            setStep("mobile"); // This updates your UI text automatically
            await sendOtpToMobile(mobile);
          } else {
            // navigate("/login");
            dispatch(
              //   loginUser({ email: email, password: formData?.password }),
              loginUser({
                email: parsedPayload?.email_id || email,
                password: parsedPayload?.password || "",
              }),
            )
              .unwrap()
              .then((data) => {
                toast.success(data.message || "Login successful");

                setUser(data?.data);
                navigate("/");
                // setUser(data.data)
              })
              .catch((err) => {
                toast.error(err || "Login failed");
              });
          }
        } else {
          // --- MOBILE SUCCESS ---
          document.dispatchEvent(
            new CustomEvent("mdm:otp", { detail: { status: "verified" } }),
          );
          alert("✅ Mobile Verified Successfully!");
          //   dispatch(setAuthData(data));
          setUser(data.user);
          // navigate("/login");
          //   navigate("/paywall");

          dispatch(
            //   loginUser({ email: email, password: formData?.password }),
            loginUser({
              email: parsedPayload?.email_id || email,
              password: parsedPayload?.password || "",
            }),
          )
            .unwrap()
            .then((data) => {
              toast.success(data.message || "Login successful");

              setUser(data?.data);
              navigate("/");
              // setUser(data.data)
            })
            .catch((err) => {
              toast.error(err || "Login failed");
            });
        }
      } else {
        alert(
          "❌ Verification Failed: " +
            (data?.message || data?.error || "Invalid OTP"),
        );
      }
    } catch (error) {
      console.error("Verification Error:", error);
      alert("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = async () => {
    setLoading(true);

    try {
      // 1. Determine which URL to hit
      const targetApi = step === "email" ? generateOtp : generateMobOtp;

      // 2. Prepare the correct payload for each step
      const payload =
        step === "email"
          ? { to: email, otpType: "email" }
          : { otpType: "mobile", to: mobile };

      const response = await fetch(targetApi, {
        method: "POST",
        // headers: { "Content-Type": "application/json" },
        headers: apiKeyHeader(),
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        document.dispatchEvent(
          new CustomEvent("mdm:otp", { detail: { status: "sent" } }),
        );
        alert(
          `OTP resent successfully to your ${step === "email" ? "Email" : "Mobile"}.`,
        );
      } else {
        alert(
          "Failed to resend OTP: " + (data.error || "Please try again later."),
        );
      }
    } catch (error) {
      console.error("Resend OTP error:", error);
      alert("Network error during OTP resend.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelVerification = () => {
    const confirmCancel = window.confirm(
      "Are you sure you want to quit verification?",
    );
    if (confirmCancel) {
      // navigate(-1);
      // navigate("/signup"); // 🔁 or any route where you want to send the user
      navigate("/home"); // 🔁 or any route where you want to send the user
    }
  };

  return (
    <div className="signup-page">
      <Toaster position="top-right" />

      {/* Animated background blobs */}
      <motion.div
        className="signup-blob signup-blob-1"
        animate={{
          x: [0, 30, -20, 0],
          y: [0, -40, 20, 0],
          scale: [1, 1.1, 0.95, 1],
        }}
        transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="signup-blob signup-blob-2"
        animate={{
          x: [0, -40, 25, 0],
          y: [0, 30, -30, 0],
          scale: [1, 0.95, 1.1, 1],
        }}
        transition={{ duration: 25, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="signup-blob signup-blob-3"
        animate={{
          x: [0, 20, -30, 0],
          y: [0, -20, 40, 0],
          scale: [1, 1.05, 0.9, 1],
        }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />

      <AnimatePresence mode="wait">
        <motion.div
          className="signup-card"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          style={{ position: "relative" }}
        >
          {/* Close / Back button */}
          {/* <motion.button
            className="signup-back-btn"
            onClick={handleCancelVerification}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            ✕
          </motion.button> */}

          {/* Header */}
          <motion.button
            className="signup-back-btn-new"
            style={{
              position: "absolute",
              top: "16px",
              right: "16px", // ✅ RIGHT-MOST
            }}
            onClick={handleCancelVerification}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            ✕
          </motion.button>
          <div className="signup-card-header">
            {/* <motion.button
              className="signup-back-btn"
              style={{ marginLeft: "85%" }}
              onClick={handleCancelVerification}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              ✕
            </motion.button> */}
            {/* <motion.button
              className="signup-back-btn"
              style={{ marginLeft: "85%" }}
              onClick={handleCancelVerification}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              ✕
            </motion.button> */}
            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              style={{ position: "relative" }}
              // style={{ marginLeft: "2%" }}
            >
              Verify {step === "email" ? "Email" : "Mobile"}
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
            >
              Enter the OTP sent to{" "}
              <strong>{step === "email" ? email : mobile}</strong>
            </motion.p>
          </div>

          {/* OTP Form */}
          <motion.form
            className="signup-form"
            onSubmit={handleVerifyOtp}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <div className="signup-field">
              <label>OTP</label>
              <div className="signup-input-wrapper">
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  maxLength={10}
                />
              </div>
            </div>

            <motion.button
              type="submit"
              className="signup-submit-btn"
              disabled={loading}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </motion.button>
          </motion.form>

          {/* Footer */}
          <motion.p
            className="signup-footer-text"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            Didn’t receive OTP?{" "}
            <span className="signup-login-link" onClick={handleResendOtp}>
              Resend OTP
            </span>
          </motion.p>
        </motion.div>
      </AnimatePresence>
    </div>
    // <div
    //   style={{
    //     maxWidth: "400px",
    //     margin: "2rem auto",
    //     padding: "2rem",
    //     border: "1px solid #ccc",
    //     borderRadius: "8px",
    //   }}
    // >
    //   {/* {JSON.stringify(payload)} */}
    //   <div className="d-flex justify-content-end">
    //     <button
    //       type="button"
    //       className="btn-close"
    //       aria-label="Close"
    //       onClick={handleCancelVerification}
    //       style={{ fontSize: "0.5rem" }}
    //     ></button>
    //   </div>

    //   <p className="mb-4 text-center">
    //     Verify {step === "email" ? "Email" : "Mobile"}
    //   </p>
    //   <p className="text-center">
    //     Enter the OTP sent to{" "}
    //     <strong>{step === "email" ? email : mobile}</strong>
    //   </p>

    //   <form onSubmit={handleVerifyOtp}>
    //     <div className="mb-3">
    //       <input
    //         type="text"
    //         className="form-control"
    //         placeholder="Enter  OTP"
    //         value={otp}
    //         onChange={(e) => setOtp(e.target.value)}
    //         maxLength={10}
    //       />
    //     </div>

    //     <button
    //       type="submit"
    //       className="btn btn-success w-100"
    //       disabled={loading}
    //     >
    //       {loading ? "Verifying..." : "Verify OTP"}
    //     </button>
    //   </form>

    //   <div className="text-center mt-3">
    //     <button
    //       className="btn btn-link"
    //       onClick={handleResendOtp}
    //       disabled={loading}
    //     >
    //       Resend OTP
    //     </button>
    //   </div>
    // </div>
  );
};

export default OtpVerification;
